// A idade de uma medição de saúde — lógica pura.
//
// POR QUE ISTO EXISTE (issue #480): a tela de métricas monta o destaque com
// `latestOf`, que devolve a primeira linha de uma janela de NOVENTA dias. Com
// o sync parado desde 04/08, ela mostrou passos, FC e HRV de onze dias atrás
// como se fossem de hoje — sem uma palavra. Num módulo de SAÚDE, número velho
// apresentado como atual é pior que tela vazia: a pessoa decide em cima dele.

/** A partir de quantos dias a medição deixa de valer como "o seu número de hoje". */
export const STALE_AFTER_DAYS = 2;

export interface MetricAge {
  days: number;
  /** Velho o bastante para a tela avisar em vez de só mostrar. */
  stale: boolean;
}

/**
 * Quantos dias tem a medição.
 *
 * `now` é parâmetro, não `Date.now()` interno — é o que torna isto testável
 * sem mock de relógio (mesma escolha do `shouldSend` do sentryDedupe).
 * Data inválida devolve idade zero e NÃO marca como velha: inventar "velho"
 * em cima de dado ilegível seria alarme falso.
 */
export function metricAge(recordedAt: string, now: number): MetricAge {
  const t = Date.parse(recordedAt);
  if (!Number.isFinite(t)) return { days: 0, stale: false };
  const days = Math.max(0, Math.floor((now - t) / 86_400_000));
  return { days, stale: days >= STALE_AFTER_DAYS };
}
